import { lazy } from 'react';

import { AppRoute } from '.';

const Profile = lazy(() => import('../pages/users/Profile'));
const Notifications = lazy(() => import('../pages/users/Notifications'));
const OAuthCallback = lazy(() => import('../pages/auth/OAuthCallback'));

const usersRouter: AppRoute[] = [{
    path: '/user',
    component: Profile,
    exact: true
}, {
    path: '/notifications/:id?',
    component: Notifications,
    exact: true
}, {
    path: '/oauth-callback/:provider',
    component: OAuthCallback,
    exact: true
}];

export default usersRouter;
